__turbopack_context__.v({
  "button": "AuthTotpForm-module-scss-module__NRH6UG__button",
  "icon": "AuthTotpForm-module-scss-module__NRH6UG__icon",
  "text": "AuthTotpForm-module-scss-module__NRH6UG__text",
});
